import { action } from "@ember/object"
import { later } from "@ember/runloop"
import Component from "@glimmer/component"
import { tracked } from "@glimmer/tracking"
import { easeIn, easeOut } from "ember-animated/easings/cosine"
import { fadeIn, fadeOut } from "ember-animated/motions/opacity"

interface Signature {
  Args: {
    isSidebar?: boolean
    isHalfScreen?: boolean
    order: number
    closeModal: Function
    noBackground?: boolean
  }
  Blocks: {
    default?: any
  }
}

export default class SlideoutWrapper extends Component<Signature> {
  @tracked elementInserted = false

  @action insertElementCallback() {
    later(() => {
      this.elementInserted = true
    }, 250)
  }

  *transition({ insertedSprites, keptSprites, removedSprites }) {
    insertedSprites.forEach((sprite) => {
      sprite.startAtPixel({ x: window.innerWidth })
      fadeIn(sprite, { easing: easeOut, duration: 150 })
    })

    keptSprites.forEach(fadeIn)

    removedSprites.forEach((sprite) => {
      fadeOut(sprite, { easing: easeIn, duration: 150 })
    })
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    SlideoutWrapper: typeof SlideoutWrapper
  }
}
